<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      :editConfig="{
        trigger: 'manual',
        mode: 'row',
        showStatus: true
      }"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame group-title">
            {{ $l('form_group_out_detail') || '出库明细' }}
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              v-if="!disabled"
              size="sm"
              variant="outline-success"
              @click="fromLoad('add')"
            >
              {{ $l('form_table_btn_choice') || '选择库存面料' }}
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div v-if="!disabled">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="editRowEvent(row)"
              v-if="!disabled"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="removeRowEvent(row)"
              v-if="!disabled"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:fabricName="{ row }">
        <span>{{ row.fabricName }}</span>
        <br />
        <span>{{ row.fabricNameEn }}</span>
      </template>
      <template v-slot:fabricContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>
      <template v-slot:wid="{ row }">
        <span>{{ row.wid }} </span>
        <span>{{ row.widUnit }}</span>
      </template>
      <template v-slot:fabricWeight="{ row }">
        <span>{{ row.fabricWeight }} </span>
        <span>{{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:unitPrice="{ row }">
        <span>{{ row.unitPrice }} </span>
        <span>{{ row.fabricUnit }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <choose-fabric-stock
      ref="chooseFabricStock"
      @saveChooseCode="saveChooseCode"
    />
  </div>
</template>

<script>
export default {
  props: {
    mainType: {
      type: String
    },
    disabled: {
      default: true,
      type: Boolean
    },
    tableData: {
      default: () => []
    }
  },
  components: {
    ChooseFabricStock: () => import('../../choose-fabric-stock')
  },
  data() {
    return {
      loading: false,
      tablePage: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0
      },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        }
      },
      tableColumn: [
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 120,
          fixed: 'right',
          slots: {
            default: 'opt'
          }
        },
        // { width: 50, fixed: 'left', type: this.single ? 'radio' : 'checkbox' },
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'fabricColorNo',
          width: 200,
          title: this.$l('INDEX.label_fabric_color_number') || '库存编号'
        },
        {
          field: 'fabricColorTitle',
          width: 200,
          title: this.$l('INDEX.choose_fabric_color') || '面料颜色名称'
        },
        {
          field: 'fabricName',
          minWidth: 300,
          title: this.$l('INDEX.choose_fabric_fabricName') || '面料名称',
          slots: {
            default: 'fabricName'
          }
        },
        {
          field: 'requestQuantity',
          width: 120,
          title:
            this.$l('INDEX.label_inventory_quantity(meters)') || '库存数量(米)'
        },
        {
          field: 'outQuantity',
          minWidth: 150,
          title: this.$l('label_number_of_out(meters)') || '出库数量(米)',
          showOverflow: true,
          editRender: {
            name: '$input',
            props: { type: 'float', digits: 2, min: 0 }
          }
        },
        {
          field: 'unitPrice',
          width: 120,
          title: this.$l('INDEX.choose_fabric_price') || '单价',
          slots: {
            default: 'unitPrice'
          }
        },
        {
          field: 'wid',
          width: 120,
          title: this.$l('INDEX.choose_fabric_wid') || '门幅',
          slots: {
            default: 'wid'
          }
        },
        {
          field: 'fabricWeight',
          width: 120,
          title: this.$l('INDEX.choose_fabric_weight') || '克重',
          slots: {
            default: 'fabricWeight'
          }
        },
        {
          field: 'userNameEn',
          width: 150,
          title: this.$l('INDEX.choose_fabric_agent') || '业务员'
        },
        {
          field: 'supName',
          minWidth: 300,
          title: this.$l('INDEX.choose_fabric_supName') || '供应商'
        },
        {
          field: 'isCustomerExclusiveColorText',
          minWidth: 300,
          title: this.$l('table_label_isCustomerExclusiveColor') || '是否客户专属颜色'
        }
      ]
    }
  },
  methods: {
    fromLoad() {
      this.$refs.chooseFabricStock.load()
    },
    editRowEvent(row) {
      const $grid = this.$refs.table
      $grid.setActiveRow(row)
    },
    removeRowEvent(row) {
      let msg = this.$l('INDEX.tips_question_delete') || '是否删除?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning'
      }).then(() => {
        let index = this.$refs.table.getRowIndex(row)
        this.tableData.splice(index, 1)
      })
    },
    getTableData() {
      return this.tableData
    },
    saveChooseCode(codeList) {
      let findCount = 0
      codeList.forEach((rowData) => {
        rowData.outQuantity = 0
        rowData.requestQuantity = rowData.stockQuantity

        this.tableData.forEach((item, index) => {
          if (rowData.fabricStockCode === item.fabricStockCode) {
            item.requestQuantity = rowData.stockQuantity
            this.$set(this.tableData, index, item)
            findCount++
          }
        })
        if (findCount === 0) {
          this.tableData.push(rowData)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}
</style>
